import React, { useState } from "react";
import {
    MapContainer,
    TileLayer,
    Marker,
    Polyline,
    Popup,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from "axios";

import { OpenStreetMapProvider } from "leaflet-geosearch";

// Ikony
const greenIcon = new L.Icon({
    iconUrl: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
});

const redIcon = new L.Icon({
    iconUrl: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
});

// Komponent do wpisania miasta i kliknięcia
function CitySearchInput({ label, onSelect }) {
    const [input, setInput] = useState("");
    const [results, setResults] = useState([]);

    const searchCity = async () => {
        const provider = new OpenStreetMapProvider();
        const results = await provider.search({ query: input });
        setResults(results);
    };

    return (
        <div style={{ marginBottom: "1px" }}>
            <label>
                <strong>{label}</strong>
            </label>
            <div
                style={{
                    display: "flex",
                    gap: "1px",
                    flexWrap: "wrap",
                    alignItems: "stretch",
                }}
            >
                <input
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="np. Warszawa"
                    style={{
                        flex: "1 1 auto",
                        padding: "1px",
                        minWidth: "0",
                        fontSize: "1rem",
                    }}
                />

                <button
                    onClick={searchCity}
                    style={{
                        padding: "1px 2px",
                        fontSize: "1rem",
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        flex: "0 0 auto",
                    }}
                >
                    🔍
                </button>
            </div>

            <ul style={{ listStyle: "none", padding: 0 }}>
                {results.map((r, i) => (
                    <li key={i}>
                        <button
                            style={{ marginTop: "5px", width: "100%", padding: "5px" }}
                            onClick={() => {
                                onSelect([r.y, r.x]);
                                setResults([]);
                                // setInput(""); // opcjonalnie czyści pole
                            }}
                        >
                            {r.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default function SearchMap() {
    const [startLocation, setStartLocation] = useState(null);
    const [endLocation, setEndLocation] = useState(null);
    const [routeCoords, setRouteCoords] = useState([]);
    const [distance, setDistance] = useState(null);
    const [duration, setDuration] = useState(null);

    const fetchRoute = async () => {
        if (!startLocation || !endLocation) return;

        try {
            // const response = await axios.post(
            //     "https://api.openrouteservice.org/v2/directions/driving-hgv/geojson",
            //     {
            //         coordinates: [
            //             [startLocation[1], startLocation[0]],
            //             [endLocation[1], endLocation[0]],
            //         ],
            //     },
            //     {
            //         headers: {
            //             Authorization:
            //                 "5b3ce3597851110001cf62488e282063a425428598219123ca0de7d1",
            //             "Content-Type": "application/json",
            //         },
            //     }
            // );
            const response = await axios.post(
                "https://api.openrouteservice.org/v2/directions/driving-hgv/geojson",
                {
                    coordinates: [
                        [startLocation[1], startLocation[0]],
                        [endLocation[1], endLocation[0]],
                    ],
                    extra_info: ["tollways"], // ✅ To aktywuje opłaty
                },
                {
                    headers: {
                        Authorization: "5b3ce3597851110001cf62488e282063a425428598219123ca0de7d1",
                        "Content-Type": "application/json",
                    },
                }
            );

            const coords = response.data.features[0].geometry.coordinates.map(
                (c) => [c[1], c[0]]
            );
            setRouteCoords(coords);
            const summary = response.data.features[0].properties.summary;
            setDistance(summary.distance);
            setDuration(summary.duration);
            // Opłaty drogowe
            const tollSummary = response.data.features[0].properties.extras?.tollways?.summary;
            let totalToll = 0;
            if (tollSummary) {
                Object.values(tollSummary).forEach(seg => {
                    if (seg.amount) totalToll += seg.amount;
                });
            }
            setTollAmount(totalToll); // 👈 nowy useState

        } catch (error) {
            console.error("Błąd podczas pobierania trasy:", error);
        }
    };
    const [tollAmount, setTollAmount] = useState(0);

    const formatDuration = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.round((seconds % 3600) / 60);
        return `${h}h ${m}min`;
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: window.innerWidth < 768 ? "column" : "row",
                height: "100vh",
            }}
        >
            {/* Lewy panel */}
            <div
                style={{
                    width: window.innerWidth < 768 ? "100%" : "300px",
                    padding: "10px",
                    background: "#f9f9f9",
                    overflowY: "auto",
                }}
            >
                <CitySearchInput label="Start" onSelect={setStartLocation} />
                <CitySearchInput label="Cel" onSelect={setEndLocation} />
                <button
                    onClick={fetchRoute}
                    style={{
                        marginTop: "10px",
                        padding: "10px",
                        width: "100%",
                        backgroundColor: "#1976d2",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        fontWeight: "bold",
                    }}
                >
                    Szukaj trasy
                </button>

                {distance && duration && (
                    <div style={{ marginTop: "20px" }}>
                        <p><strong>Dystans:</strong> {(distance / 1000).toFixed(1)} km</p>
                        <p><strong>Czas przejazdu:</strong> {formatDuration(duration)}</p>
                        <button
                            onClick={() => alert(`Opłaty: ${tollAmount.toFixed(2)} €`)}
                            style={{
                                marginTop: "10px",
                                padding: "10px",
                                width: "100%",
                                backgroundColor: "#4caf50",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                cursor: "pointer",
                            }}
                        >
                            Pokaż opłaty
                        </button>
                    </div>
                )}
            </div>

            {/* Mapa */}
            <div style={{ flex: 1 }}>
                <MapContainer center={[50.5, 11]} zoom={5} style={{ height: "100%", width: "100%" }}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href=\"https://www.openstreetmap.org/\">OpenStreetMap</a> contributors'
                    />

                    {startLocation && (
                        <Marker position={startLocation} icon={greenIcon}>
                            <Popup>Start</Popup>
                        </Marker>
                    )}
                    {endLocation && (
                        <Marker position={endLocation} icon={redIcon}>
                            <Popup>Cel</Popup>
                        </Marker>
                    )}
                    {routeCoords.length > 0 && (
                        <Polyline positions={routeCoords} color="blue" />
                    )}
                </MapContainer>
            </div>
        </div>
    );
}